import React from "react";

const baselines = [
  'SFT and SFT + DPO fine-tuned models',
  'Official RLHF-aligned releases',
  'State-of-the-art models with augmented data',
  'Cross-family comparison with Llama2-7B-Chat',
];

const wins = [
  <>Reduces ASR from <strong className="text-ink-900">93% → &lt;1%</strong> in several jailbreak settings</>,
  <>Competes with or surpasses models fine-tuned via <strong className="text-ink-900">DPO / RLHF</strong></>,
  <>Beats state-of-the-art augmented-data models</>,
  <>Upgrades <strong className="text-ink-900">Mistral-7B-Instruct</strong> to exceed Llama2-7B-Chat in safety</>,
];

function Figure({ src, alt, caption }) {
  return (
    <figure className="card p-4 md:p-5">
      <div className="rounded-xl overflow-hidden bg-white">
        <img src={src} alt={alt} className="w-full h-auto" />
      </div>
      <figcaption className="figure-caption">{caption}</figcaption>
    </figure>
  );
}

export default function Experiment() {
  return (
    <section className="py-20 bg-ink-50/60 border-t border-ink-100">
      <div className="max-w-5xl mx-auto px-6">
        <p className="section-eyebrow mb-3">04 &middot; Results</p>
        <h2 className="section-title">Experiment Results</h2>

        <div className="mt-10 prose-paper space-y-5 max-w-3xl mx-auto">
          <p>
            We evaluate our approach using{' '}
            <strong>Llama2-7B</strong> as the base model and{' '}
            <strong>Mistral-7B-Instruct-v0.2</strong> as the aligned model.
          </p>
        </div>

        <div className="mt-8 grid md:grid-cols-2 gap-4">
          <div className="card p-6">
            <div className="text-xs font-semibold uppercase tracking-widest text-ink-500">
              Baselines
            </div>
            <ul className="mt-3 space-y-2 text-sm text-ink-700">
              {baselines.map((b, i) => (
                <li key={i} className="flex gap-2 items-start">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-ink-400 shrink-0" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="card p-6">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand-600">
              Our wins
            </div>
            <ul className="mt-3 space-y-2 text-sm text-ink-700">
              {wins.map((w, i) => (
                <li key={i} className="flex gap-2 items-start">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-brand-500 shrink-0" />
                  <span>{w}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 space-y-8">
          <Figure
            src="/figures/experiments1.jpg"
            alt="Experiment Results 1"
            caption="Figure 4. Safety performance across jailbreak attack settings."
          />
          <Figure
            src="/figures/experiments2.jpg"
            alt="Experiment Results 2"
            caption="Figure 5. Comparison against RLHF-aligned and augmented-data baselines."
          />
        </div>

        <div className="mt-10 prose-paper max-w-3xl mx-auto">
          <p>
            These results align with the{' '}
            <strong>Superficial Safety Alignment Hypothesis</strong> and
            confirm that <strong>explicit</strong> safety signals substantially
            improve model robustness.
          </p>
        </div>
      </div>
    </section>
  );
}
